// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as PasswordActions } from '../../password/duck';
import { actions as AlertActions } from '../../../alert/duck';
import Password from '../components/Password';

import type { RootState } from '../../../index';

function mapStateToProps(state: RootState) {
  return {
    isPuttingPassword: state.preferences.password.isPuttingPassword,
    editSuccessful: state.preferences.password.editSuccessful,
    putPasswordError: state.preferences.password.putPasswordError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...PasswordActions, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Password);



// WEBPACK FOOTER //
// ./src/modules/preferences/password/containers/PasswordContainer.js